import {get, pipe} from '@yandex-delivery/utils'
import {templateFormatter} from 'input-format'

import {PhoneRule} from './types'
import {getDigits} from './utils'

export const DEFAULT_MASK = '+x (xxx) xxx-xxxxx xx'

type RegexpCache = {
  [key: string]: RegExp
}

const regexpCache: RegexpCache = {}

type PhoneRuleCache = {
  [key: string]: PhoneRule
}

const cache: PhoneRuleCache = {}

type FormattedCache = {
  [key: string]: string
}

const formattedCache: FormattedCache = {}
const getCachedRegexp = (string: string) => {
  if (regexpCache[string]) {
    return regexpCache[string]
  }
  const regexp = new RegExp(string)
  regexpCache[string] = regexp
  return regexp
}

export const getRule = (phoneRules: PhoneRule[], phone: string) => {
  return phoneRules?.find(rule => rule.matches?.find(prefix => getCachedRegexp(prefix).test(getDigits(phone))))
}
export const getMask = (
  phoneRules: PhoneRule[],
  phone: string | undefined,
  defaultMask: string | undefined = DEFAULT_MASK,
) => {
  if (!phone) {
    return defaultMask
  }
  const rule = cache[phone] || getRule(phoneRules, phone)
  if (!cache[phone]) {
    cache[phone] = rule
  }
  return rule ? rule.mask : defaultMask
}

// fixme pls 🥴🔫
export function normalizePhone(rules: PhoneRule[], localReplacements?: Record<string, string>) {
  let _getDigits = getDigits

  if (localReplacements) {
    const _localReplacements = Object.entries(localReplacements).map(([regex, replacement]) => ({
      regex: new RegExp(regex),
      replacement,
    }))

    _getDigits = function _getDigits(phone: string) {
      return _localReplacements.reduce(
        (phone, {regex, replacement}) => phone.replace(regex, replacement),
        getDigits(phone),
      )
    }
  }

  return function _normalizePhone(phone: string) {
    const dryPhone = _getDigits(phone)

    return pipe(
      getRule(rules, _getDigits(format(rules)(phone))),
      get('prefixes'),
      // смотрим, если телефон подходит под префикс без плюса, а в самом префиксе плюс есть - значит должен быть и в телефоне
      (prefixes?: string[]) => {
        const hasPlus = prefixes?.some(prefix => dryPhone.startsWith(prefix.replace('+', '')) && prefix.includes('+'))

        return hasPlus ? '+' : ''
      },
      (prefix: string) => prefix + dryPhone,
    )
  }
}

export const format = (phoneRules: PhoneRule[]) => (phone: string) => {
  if (formattedCache[phone]) {
    return formattedCache[phone]
  }
  const mask = getMask(phoneRules, phone)
  const formatted = templateFormatter(mask as string)(getDigits(phone)).text
  formattedCache[phone] = formatted
  return formatted
}

export const isValid = (phoneRules: PhoneRule[]) => (phone?: string) => {
  if (!phone) {
    return false
  }
  const digitsCount = getDigits(phone).length
  const rule = getRule(phoneRules, phone)
  return rule !== undefined && rule.min_length <= digitsCount && rule.max_length >= digitsCount
}
